module.exports = __webpack_public_path__ + "static/img/9.a73d257.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/2/zh/9.png
// module id = eBqe
// module chunks = 0